import { defineMessages, IntlShape } from "react-intl";

import FeatureRequestKey from "@app/enum/FeatureRequestKey";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages({
  [FeatureRequestKey.ADVANCED_REPORTING]: {
    id: "features.displayName.advancedReporting",
    defaultMessage: "Advanced Reporting",
    description: "Display name for the Advanced Reporting feature",
  },
  [FeatureRequestKey.DATA_MERGING]: {
    id: "features.displayName.dataMerging",
    defaultMessage: "Data Merging",
    description: "Display name for the Data Merging feature",
  },
  [FeatureRequestKey.DEMOGRAPHICS]: {
    id: "features.displayName.demographics",
    defaultMessage: "Demographics",
    description: "Display name for the Demographics feature",
  },
  [FeatureRequestKey.EMAIL]: {
    id: "features.displayName.email",
    defaultMessage: "Email",
    description: "Display name for the Email feature",
  },
  [FeatureRequestKey.LEAD_FINDER_ADVANCED]: {
    id: "features.displayName.leadFinderAdvanced",
    defaultMessage: "Lead Finder Advanced",
    description: "Display name for the Lead Finder Advanced feature",
  },
  [FeatureRequestKey.LEAD_FINDER_ELITE]: {
    id: "features.displayName.leadFinderElite",
    defaultMessage: "Lead Finder Elite",
    description: "Display name for the Lead Finder Elite feature",
  },
  [FeatureRequestKey.LEAD_FINDER_STARTER]: {
    id: "features.displayName.leadFinderStarter",
    defaultMessage: "Lead Finder Starter",
    description: "Display name for the Lead Finder Starter feature",
  },
  [FeatureRequestKey.MILEAGE_TRACKER]: {
    id: "features.displayName.mileageTracker",
    defaultMessage: "Mileage Tracker",
    description: "Display name for the Mileage Tracker feature",
  },
  [FeatureRequestKey.ONBOARDING]: {
    id: "features.displayName.onboarding",
    defaultMessage: "Onboarding",
    description: "Display name for the Onboarding feature",
  },
  [FeatureRequestKey.PHI]: {
    id: "features.displayName.phi",
    defaultMessage: "PHI",
    description: "Display name for the PHI feature",
  },
  [FeatureRequestKey.RESOURCES]: {
    id: "features.displayName.resources",
    defaultMessage: "Resources",
    description: "Display name for the Resources feature",
  },
  [FeatureRequestKey.TERRITORIES]: {
    id: "features.displayName.territories",
    defaultMessage: "Manual Territories",
    description: "Display name for the Manual Territories feature",
  },
});

const getFeatureDisplayName = (intl: IntlShape, featureKey: FeatureRequestKey): string =>
  getDisplayName(intl, messages, featureKey, "FeatureRequestKey");

export default getFeatureDisplayName;
